export default "__VITE_ASSET__DbTEjbRO__"